"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FolderMoveSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M15,8 L14,8 L14,6 L4,6 L4,14 L10,14 L10,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L3,4 C3,3.44771525 3.44771525,3 4,3 L7.27924078,3 C7.70967119,3 8.09181003,3.27543009 8.22792408,3.68377223 L8.66666667,5 L14,5 C14.5522847,5 15,5.44771525 15,6 L15,8 Z M4,5 L7.61257411,5 L7.27924078,4 L4,4 L4,5 Z M17.2071068,12.5 L14.8498657,14.8590511 C14.6567143,15.0523507 14.3434339,15.0524709 14.1501343,14.8593196 C13.9564311,14.6656165 13.9556837,14.3520105 14.1483279,14.1575212 L15.2948673,13 L12,13 L12,12 L15.2948673,12 L14.1474284,10.843568 C13.9555245,10.65016 13.9566757,10.3378238 14.15,10.1458356 C14.3435516,9.95362177 14.6560631,9.95400875 14.8491381,10.1467013 L17.2071068,12.5 Z" })));
};
FolderMoveSmall.displayName = 'FolderMoveSmall';
exports.default = FolderMoveSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FolderMoveSmall.js.map